const SERVER_URL =
  "https://amberwoodre-backend-nodejs-cpmn6gngia-wl.a.run.app/";
// "http://192.168.29.179:8080/"
const IMAGE_URL = "https://storage.googleapis.com/cdn-amberwoodre/";
const AGENT_ID = "6a206ac2e9ce4b74ee38ff0e";
module.exports = {
  SERVER_URL,
  IMAGE_URL,
  AGENT_ID,
};
